<style lang="less" scoped>
.first {position: relative;width: 1200px;display: flex;flex-direction: column;justify-content: center;align-items: center;margin: 0px auto;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 60px;}
.chxxb {display: flex;flex-direction: column;}
.formBox{width: 1180px;margin-left: -20px;margin-top: 0px;}
table {border-collapse: collapse;width: 100%;}
tr,td {border: 1px solid #f5eeee;padding: 5px;border: 1px solid #e2e1e1;}
.f_red {color: red;margin-right: 5px;}
.f_hid {color: #ffffff;margin-right: 5px;}
.td_left {width: 200px;text-indent: 10px;background-color: #fcfcfc;}
.td_center{width: 200px;background-color: #fcfcfc;}
.td_right {background-color: #fcfcfc;padding-left: 10px;}
.td_right span{font-size: 16px;}
.el-input {width: 400px;}
.el-select {width: 400px;}
.el-form-item {margin-bottom: 0;float: left;}
.btn{margin-top: 40px;}
</style>

<template>
  <div class="first">
    <div class="chxxb" id="hyrc">
      <el-form ref="form" :model="form" :rules="rules" class="formBox">
        <table>
          <tr class="tr">
            <td class="td_left" rowspan="5">基本信息</td>
            <td class="td_center">
              <span v-if="isMandatory('hyname')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>会议名称
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.hyname" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('hyzt')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>会议主题
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.hyzt" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('nhsj')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>拟办会时间
            </td>
            <td class="td_right">
              <el-input v-model="form.nhsj" class="input" style="float:left;"></el-input>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('nhaad')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>拟办会地点
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.nhaad" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('nhgm')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>拟办会规模
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.nhgm" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left" rowspan="6">主办方</td>
            <td class="td_center">
              <span v-if="isMandatory('gsname')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司名称
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.gsname" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('gsaad')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司地址
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.gsaad" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('gstype')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司性质
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.gstype" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('lxrname')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>联系人
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.lxrname" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('tel')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>联系电话
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.tel" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('mall')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>邮箱
            </td>
            <td class="td_right">
              <el-form-item prop="email">
                <el-input v-model="form.mall" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left" rowspan="6">协办方</td>
            <td class="td_center">
              <span v-if="isMandatory('xbname')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司名称
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.xbname" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('xbgsaad')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司地址
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.xbgsaad" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('xbgstype')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司性质
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.xbgstype" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('xblxr')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>联系人
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.xblxr" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('xbtel')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>联系电话
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.xbtel" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('xbmall')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>邮箱
            </td>
            <td class="td_right">
              <el-form-item prop="email">
                <el-input v-model="form.xbmall" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left" rowspan="6">媒体</td>
            <td class="td_center">
              <span v-if="isMandatory('mtname')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司名称
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.mtname" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('mtaad')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司地址
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.mtaad" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('mttype')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司性质
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.mttype" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('mtlxr')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>联系人
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.mtlxr" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('mttel')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>联系电话
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.mttel" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('mtmall')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>邮箱
            </td>
            <td class="td_right">
              <el-form-item prop="email">
                <el-input v-model="form.mtmall" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">其它</td>
            <td class="td_center">
              <span v-if="isMandatory('opacity')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>留言
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.opacity" class="input" style="width:740px;"></el-input>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
    </div>
    <div class="btn">
      <el-button type="primary" @click="backtrack">返回</el-button>
    </div>
  </div>
</template>

<script>
/**
 * 何宽
 * 办会报名页
 */
import filters from '../method/filter'
export default {
  mixins: [filters],
  data()
  {
    return {
      form: {
        hyname: '',
        hyzt: '',
        nhsj: null,
        nhaad: '',
        nhgm: '',
        gsname: '',
        gsaad: '',
        gstype: '',
        lxrname: '',
        tel: '',
        mall: '',
        xbname: '',
        xbgsaad: '',
        xbgstype: '',
        xblxr: '',
        xbtel: '',
        xbmall: '',
        mtname: '',
        mtaad: '',
        mttype: '',
        mtlxr: '',
        mttel: '',
        mtmall: '',
        opacity: ''
      },
      //表名
      tabname: 'dmcn_bhxxb',
      //fld表数据
      fldData: []
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.getdata(+nval.query.id)
      },
      immediate: true
    }
  },
  async created()
  {
    this.fldData = await window.public.validation(this.tabname)
  },
  methods: {
    // 获取参会报名信息
    getdata(num)
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 61,
        _exp: 'id=?',
        types: 'i',
        vals: num
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.hyname = ret[0].hyname
        this.form.hyzt = ret[0].hyzt
        let date = new Date(parseInt(ret[0].nhsj * 1000))
        let y = date.getFullYear()
        let MM = date.getMonth() + 1
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let h = date.getHours()
        h = h < 10 ? ('0' + h) : h
        let m = date.getMinutes()
        m = m < 10 ? ('0' + m) : m
        let s = date.getSeconds()
        s = s < 10 ? ('0' + s) : s
        this.form.nhsj = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
        this.form.nhaad = ret[0].nhaad
        this.form.nhgm = ret[0].nhgm
        this.form.gsname = ret[0].gsname
        this.form.gsaad = ret[0].gsaad
        this.form.gstype = ret[0].gstype
        this.form.lxrname = ret[0].lxrname
        this.form.tel = ret[0].tel
        this.form.mall = ret[0].mall
        this.form.xbname = ret[0].xbname
        this.form.xbgsaad = ret[0].xbgsaad
        this.form.xbgstype = ret[0].xbgstype
        this.form.xblxr = ret[0].xblxr
        this.form.xbtel = ret[0].xbtel
        this.form.xbmall = ret[0].xbmall
        this.form.mtname = ret[0].mtname
        this.form.mtaad = ret[0].mtaad
        this.form.mttype = ret[0].mttype
        this.form.mtlxr = ret[0].mtlxr
        this.form.mttel = ret[0].mttel
        this.form.mtmall = ret[0].mtmall
        this.form.opacity = ret[0].opacity
      })
    },
    // 返回
    backtrack()
    {
      this.$router.go(-1)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/BhbmShow.vue